import { useEffect, useState } from 'react'

export const useBoxHighlight = (
  externalHighlight?: string[]
): [string[], React.Dispatch<React.SetStateAction<string[]>>] => {
  const [internalHighlight, setInternalHighlight] = useState<string[]>(
    externalHighlight ?? []
  )

  useEffect(() => {
    setInternalHighlight(externalHighlight ?? [])
  }, [externalHighlight])

  return [internalHighlight, setInternalHighlight]
}
